import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import WhatsAppIcon from "./WhatsAppIcon";
import EuronovaLogo from "./EuronovaLogo";
import { useLanguage } from "@/contexts/LanguageContext";
import MailtoLink from "./MailtoLink";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-border bg-card">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <EuronovaLogo className="h-16" />
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-xs">
              {t.footer.description}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="https://www.facebook.com/printariamea" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-border hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2] transition-all duration-200 text-muted-foreground" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/euronova2000" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-border hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white hover:border-transparent transition-all duration-200 text-muted-foreground" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="https://wa.me/40722516603" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-border hover:bg-[#25D366] hover:text-white hover:border-[#25D366] transition-all duration-200 text-muted-foreground" aria-label="WhatsApp">
                <WhatsAppIcon size={18} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-foreground mb-4">
              {t.footer.navigation}
            </h3>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t.nav.aboutUs}</Link>
              <Link to="/servicii" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t.nav.services}</Link>
              <Link to="/proiecte" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t.nav.projects}</Link>
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">{t.nav.contact}</Link>
            </div>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-foreground mb-4">
              {t.footer.contact}
            </h3>
            <div className="flex flex-col gap-3 text-sm text-muted-foreground">
              <a href="https://www.google.com/maps/search/?api=1&query=Str.+Codrului+nr.+11,+Magurele,+Ilfov" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Str. Codrului nr. 11, Măgurele – Ilfov</a>
              <MailtoLink email="printuri@gmail.com" className="hover:text-primary transition-colors">printuri@gmail.com</MailtoLink>
              <a href="tel:+40722516603" className="hover:text-primary transition-colors">+40 722 516 603</a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Euro Nova. {t.footer.rights}</span>
          <div className="flex items-center gap-4">
            <Link to="/politica-cookies" className="hover:text-primary transition-colors">{t.footer.cookiePolicy}</Link>
            <Link to="/politica-confidentialitate" className="hover:text-primary transition-colors">{t.footer.privacy}</Link>
            <Link to="/admin-login" className="hover:text-primary transition-colors">{t.footer.adminAccess}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
